const state = {
    dataGrid: {
        colFilter: null,
        colSort: [],
    },

};

const getters = {
    getColFilter: state => {
        return state.dataGrid.colFilter;
    },
    getColSort: state => {
        return state.dataGrid.colSort;
    },
};

const mutations = {
    setColFilter: (state, payload) => {
        state.dataGrid.colFilter = payload;
    },
    setColSort: (state, payload) => {
        state.dataGrid.colSort = payload;
    },
};

const actions = {
    setColFilter: ({ commit }, payload) => {
        commit('setColFilter', payload);
    },
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}